import React, { useState } from "react";
import { Modal, Input, notification, Button } from "antd";
import { addCandidateNote } from "api/candidate.api";
import { useSelector } from "react-redux";

const { TextArea } = Input;

interface CandidateNotesModalProps {
    isModalOpen: boolean;
    setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    candidateId: number;
}

const CandidateNotesModal: React.FC<CandidateNotesModalProps> = ({ isModalOpen, setIsModalOpen, candidateId }) => {
    const [note, setNote] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const userData = useSelector((state: any) => state.user.user);

    // Function to handle closing the modal
    const handleCancel = (): void => {
        setIsModalOpen(false); // Close the modal
    };

    // Function to handle the API call and close the modal after submission
    const submitNote = async (): Promise<void> => {
        try {
            setLoading(true);
            // Prepare the payload with note and candidateId
            const candidateNotePayload = {
                candidate: candidateId, // The ID of the candidate
                custom_fields: {
                    note: note, // The note entered by the user
                    modified_date: new Date(),
                    edited_by: userData?.first_name,
                    is_edited: false
                }
            };

            // Call your API here and pass the payload as part of the request
            const response = await addCandidateNote(candidateNotePayload);

            if (response) {
                notification.success({
                    message: "Success",
                    description: "Note added successfully!"
                });
                setNote("");
                setIsModalOpen(false);
            } else {
                notification.error({
                    message: "Failed",
                    description: "Failed to submit the note"
                });
            }
        } catch (error) {
            notification.error({
                message: "Failed",
                description: "An error occurred while submitting the note"
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title="Candidate Note"
            open={isModalOpen}
            onCancel={handleCancel}
            footer={[
                <Button key="back" onClick={handleCancel}>
                    Cancel
                </Button>,
                <Button key="submit" type="primary" loading={loading} disabled={!note.trim() || loading} onClick={submitNote}>
                    Submit
                </Button>,

            ]}
        >
            <div>
                <TextArea
                    id="candidateNotes"
                    rows={4}
                    placeholder="Add Note"
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                />
            </div>
        </Modal>
    );
};

export default CandidateNotesModal;
